import { useContext } from 'react'
import { CollectionContext } from '../../state/CollectionContext'
import globalStyle from '../../styles/common.module.css'
import style from './story.module.css'



// ~~~~~~~~~~~~~~~~~~~~ STORY ~~~~~~~~~~~~~~~~~~~~
function Mode({title}: {title: string}) {
  const context = useContext(CollectionContext)
  const story = context.state.find((story) => story.isActive)
  if (!story) return null
  return (
    <div>
      <p className={[style.mode, globalStyle.subtitle].join(' ')}>
        {story.mode === 'edit' ? (
          <>
            <img src='assets/icons/editing.svg' alt='editing icon' /> 
            <span>EDITING: {title} </span>
          </>
        ) : story.mode === 'video' ? (
          <>
            <img src='assets/icons/additional.svg' alt='editing icon' /> 
            <span>ADDITIONAL: {title} </span>
          </>
        ) : (
          <>
            <img src='assets/icons/reviewing.svg' alt='editing icon' /> 
            <span>REVIEWING: {title} </span>
          </>
        )}
      </p>
    </div>
  )
}


export { Mode } 
